<template>
<div class="main">
    <div class="header">
        <div class="header_in">
            <div class="logo">
                <a href="javascript:;">
                    <img src="@/assets/img/logo.png" alt />
                </a>
            </div>
            <div class="nav">
                <div class="child">
                    <a href="http://www.haichacha.net/">
                        首页
                        <span></span>
                    </a>
                </div>
                <div class="child">
                    <a href="http://www.haichacha.net/index.php/index/category/index?id=108">
                        产品功能
                        <span></span>
                    </a>
                </div>
                <div class="child">
                    <a href="http://www.haichacha.net/index.php/index/category/index?id=109">
                        数据智能
                        <span></span>
                    </a>
                </div>
                <div class="child">
                    <a href="http://www.haichacha.net/index.php/index/category/index?id=110">
                        关于我们
                        <span></span>
                    </a>
                </div>
            </div>
            <div class="app" @mouseenter="enter()" @mouseleave="leave()">
                <a href="javascript:;">下载APP</a>

                <div class="bg" v-show="state">
                    <img src="http://www.haichacha.net/wechat.jpg" alt="">
                </div>
            </div>
            <div class="app">
                <a href="javascript:;">登录</a>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "Index",
    data() {
        return {
            state: false
        };
    },
    mounted() {},
    methods: {
        enter() {
            this.state = true;
        },
        leave() {
            this.state = false;
        },
        to(url) {
            //   console.log(url);
            //   console.log(this.$route.path);
            //   return false
            //   window.localtion.href = url
            //   window.history.pushState(url);
            // window.open('http://test.yibenyy.com/');
            window.location.href = this.$store.state.datanet + url;
        }
    },
    props: {
        msg: String
    },
    components: {}
};
</script>

<style lang="less" scoped>
a {
    text-decoration: none;
}

.main {
    .header {
        position: fixed;
        top: 0;
        width: 100%;
        height: 70px;
        box-shadow: 0px -2px 4px 0 #fff;
        transition: all 0.3s;

        .header_in {
            width: 1200px;
            height: 70px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .logo {
                width: 169px;

                a {
                    width: 170px;
                    display: block;

                    img {
                        width: 100%;
                    }
                }
            }

            .nav {
                width: 60%;
                height: 100%;
                margin-left: 120px;
                display: flex;
                align-items: center;
                justify-content: flex-end;

                .child {
                    width: 20%;
                    height: 100%;
                    position: relative;
                    text-align: center;

                    a {
                        width: 100%;
                        font-size: 18px;
                        font-weight: 600;
                        line-height: 70px;
                        color: #ffffff;
                        position: relative;
                        letter-spacing: 1px;
                        text-decoration: none;

                        span {
                            display: block;
                            width: 2px;
                            height: 3px;
                            position: absolute;
                            background-color: #3779ff;
                            bottom: -10px;
                            left: 50%;
                            margin-left: -1px;
                            opacity: 0;
                            transition: all 0.3s;
                        }
                    }
                }

                .child:hover {
                    span {
                        width: 32px;
                        opacity: 1;
                        margin-left: -16px;
                    }
                }
            }

            .app {
                width: 130px;
                height: 35px;
                background-color: #3779ff;
                border-radius: 21px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right: 30px;
                position: relative;

                a {
                    font-size: 16px;
                    color: #ffffff;
                }

                .bg {
                    width: 109px;
                    height: 115px;
                    background: url("../../assets/img/app.png") no-repeat center center;
                    background-size: cover;
                    position: absolute;
                    left: 5px;
                    top: 50px;

                    img {
                        width: 100px;
                        margin: 10px 0 0 4px;
                    }
                }
            }
        }
    }
}
</style>
